import styles from './index.module.scss';

const { needle } = styles;

interface TrackingLineProps {
    height?: number,
    width: number,
    offset?: number[],
    position?: number,
}

function TrackingLine({
  height = 0, width, offset = [0, 0, 0, 0], position = 0,
}: TrackingLineProps) {
  const calculateLeftPosition = () => {
    const leftOffset = offset[3];
    const leftPosition = ((width - offset[3]) * position) / 100;
    if (position > 100 || position < 0) {
      return offset[3];
    }

    return leftOffset + leftPosition;
  };
  return (
    <div
      className={needle}
      style={{
        height: `${height - offset[2]}px`,
        top: `${offset[0]}px`,
        left: `${calculateLeftPosition()}px`,
      }}
    />
  );
}

export default TrackingLine;
